export default function Faqs() {
  return (
    <>
 {/*


 <section id="faq">

      <div className="container" data-aos="fade-up">

        <div className="section-header">
          <h2>F.A.Q </h2>
        </div>

        <div className="row justify-content-center" data-aos="fade-up" data-aos-delay="100">
          <div className="col-lg-12">

            <ul className="faq-list">

              <li>
                <div data-bs-toggle="collapse" className="collapsed question" href="#faq1">What are the best days to book cheap flights? <i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
                <div id="faq1" className="collapse" data-bs-parent=".faq-list">
                  <p>
                    The best days to book cheap flights can vary depending on various factors such as the destination, time of year, and airline. However, research has shown that booking flights on a Tuesday or Wednesday tends to yield better deals compared to booking on weekends or Fridays.

                  </p>
                </div>
              </li>

              <li>
                <div data-bs-toggle="collapse" href="#faq2" className="collapsed question">How far in apart should I book my cheap flights? <i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
                <div id="faq2" className="collapse" data-bs-parent=".faq-list">
                  <p>
                  The ideal time to book cheap flights can vary, but generally, booking several months in advance can help you secure better deals. Airlines tend to increase their prices as the departure date approaches, so booking early can save you money. However, last-minute deals or flash sales may also occur, so it's worth keeping an eye out for those if you have flexibility in your travel plans.

                  </p>
                </div>
              </li>

              <li>
                <div data-bs-toggle="collapse" href="#faq3" className="collapsed question">Are budget airlines a good option for cheap flights?
 <i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
                <div id="faq3" className="collapse" data-bs-parent=".faq-list">
                  <p>
                  Budget airlines can be a great option for finding cheap flights, as they often offer lower fares compared to full-service airlines. However, it's important to carefully review the fare structure and any additional fees, such as baggage fees or seat selection fees, as these can add up and impact the overall cost of your flight. Also, be mindful of the amenities and services offered by budget airlines, as they may have limited in-flight services or stricter policies compared to traditional airlines.

                  </p>
                </div>
              </li>

              <li>
                <div data-bs-toggle="collapse" href="#faq4" className="collapsed question">Can I find cheap flights during peak travel seasons?
<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
                <div id="faq4" className="collapse" data-bs-parent=".faq-list">
                  <p>
                    While it can be more challenging to find cheap flights during peak travel seasons, it's not impossible. You can still try to find deals by being flexible with your travel dates, booking well in advance, or considering alternative airports. Additionally, setting up fare alerts, comparing prices on different websites, and utilizing airline rewards programs can also increase your chances of finding affordable options even during peak travel seasons.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

      </div>

    </section>
    */}
    </>
  );
}
